import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted, reactive, watch } from "vue";
import { getMediaReportsList_url } from "@/api"; //引入发送请求获取数据的方法

import { useRouter, useRoute } from "vue-router";
import MiniPagination from "@/components/MiniPagination/index.vue";
export default {
  components: {
    MiniPagination: MiniPagination
  },
  name: "Media",
  setup: function setup() {
    var route = useRoute();
    var router = useRouter();
    var activeNames = ref(0); // 展开方法

    var toggleMore = function toggleMore(index) {
      activeNames.value = index;
    }; // 收起方法


    var retract = function retract(name) {
      activeNames.value = -1;
    };

    var reportsList = ref([]);
    var currentPage = ref(1);
    var pageSize = ref("5");
    var totalCount = ref("");
    var title = ref(""); // const wd = route.query.wd

    watch(function () {
      return route.query;
    }, function () {
      if (route.query.wd) {
        title.value = route.query.wd;
      } else {
        title.value = "";
      } // getMediaReportsList()

    });

    function getMediaReportsList() {
      return _getMediaReportsList.apply(this, arguments);
    }

    function _getMediaReportsList() {
      _getMediaReportsList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {
                  currentPage: currentPage.value,
                  pageSize: pageSize.value,
                  title: title.value
                };
                _context.next = 3;
                return getMediaReportsList_url(params);

              case 3:
                result = _context.sent;

                if (result.code == 200) {
                  reportsList.value = result.data.reportsList;
                  totalCount.value = result.data.totalCount;
                  console.log("totalCount=", totalCount.value);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getMediaReportsList.apply(this, arguments);
    }

    onMounted(function () {
      getMediaReportsList(); //获取媒体报道列表
    });

    var jumpMediaDetail = function jumpMediaDetail(item) {
      if (item.jumpFlag == 1) {
        var url = item.jumpUrl;
        window.open(url);
      } else {
        router.push({
          path: '/mediaDetails',
          query: {
            reportId: item.reportId
          }
        });
        return;
      }
    };

    var handlePageChange = function handlePageChange(page) {
      currentPage.value = page;
      getMediaReportsList();
    };

    return {
      reportsList: reportsList,
      currentPage: currentPage,
      pageSize: pageSize,
      totalCount: totalCount,
      title: title,
      activeNames: activeNames,
      retract: retract,
      toggleMore: toggleMore,
      jumpMediaDetail: jumpMediaDetail,
      handlePageChange: handlePageChange
    };
  }
};